import { Input, Typography } from "@plum-xoxo/admin-dsm";
import React from "react";
import styled from "styled-components";

const StyledDiv = styled.div`
  background: ${(props) => props.theme.palette.light.c100};
  padding: 20px;
  input {
    background: ${(props) => props.theme.palette.light.c000};
  }
`;

const StyledPreview = styled.div`
  background-color: ${(props) => props.theme.palette.light.c200};
  padding: 20px;
  border-radius: 8px;
`;

const REWARD_SMS_MESSAGES = {
  1: "You have received {No. of points} {rewards title}. You can login to www.stores.xoxoday.com to view and redeem your {rewards title} and is valid {validity}. Powered by Xoxoday.",
  2: "Your Reward Code {code} worth {currencyCode} {amountValue} can be redeemed in this link - {your link} and is valid upto {validity}. Powered by Xoxoday.",
  3: "Your reward worth {worth} can be redeemed in this Reward Link - https://rewards.xoxoday.com/in/catalog/explore/1009cd6e842ed55debfa62ea8f204c26 valid till {validity}. Powered by Xoxoday.",
  4: ",this is your {brandName} gift voucher of value {currencyCode} {amountValue}, Code is {Code}. Pin is {Pin}. Expiry is {validity}. Your Xoxoday Order ID {order_id}. For details of Redemption/T&C/To View Outlets, click here {url}. For queries WhatsApp us on +91 8061915050 or email cs@giift.com.",
};
const SmsPreviewCommon = (props) => {
  const { smsText, setSmsText, rewardType } = props;
  return (
    <div className="mt-32">
      <Typography.ButtonText className="my-8">
        SMS Preview
      </Typography.ButtonText>
      <StyledDiv>
        <Input
          type="text"
          name="text"
          limit={90}
          label=" "
          value={smsText}
          onChange={(e) => setSmsText(e.target.value)}
        />
        <StyledPreview className="mt-24">
          <Typography color="dark" shade="c200">
            Hi {"{username}"},{" "}
            <Typography.ButtonText
              className="d-inline"
              color="dark"
              shade="c300"
            >
              *{smsText}* <br />
            </Typography.ButtonText>
            {REWARD_SMS_MESSAGES[rewardType]}
          </Typography>
        </StyledPreview>
      </StyledDiv>
    </div>
  );
};

export default SmsPreviewCommon;
